import _ from 'lodash';

import PropTypes from 'prop-types';

import { Label, FadeInAnimation } from '../../shared';

const BuildingHeader = (props) => {

    const { selectedBuilding, selectedBuildingRoomTypes, city } = props;

    const name = _.get(selectedBuilding, 'name');
    const addressLine1 = _.get(selectedBuilding, 'address.addressLine1');
    const addressLine2 = _.get(selectedBuilding, 'address.addressLine2');
    const isNewBuilding = _.get(selectedBuilding, 'acceptingProvisionalBookings');
    
    const getCategories = () => {
        const uniqueCategories = _.uniq(
            _.map(
                selectedBuildingRoomTypes,
                (roomType) => `${_.trim(_.get(roomType, 'category'))}`,
            ),
        );
        return _.map(uniqueCategories, (category, index) => {
            if (index < _.size(uniqueCategories) - 1) {
                return `${category} • `;
            }
            return category;
        });
    };

    return (
        <>
            {isNewBuilding && (
                <div className='building-header-label-container'>
                    <Label type="green" id="new_building_label">
                        New Building
                    </Label>
                </div>
            )}
            <FadeInAnimation>
                <h3 className='building-header-header3' id="building_header">
                    {name}
                </h3>
                <p className='building-header-address'>
                    {addressLine1}
                    {', '}
                    {addressLine2}
                    {', '}
                    {_.get(city, 'name')}
                </p>

                <p className='building-header-description'>{getCategories()}</p>
            </FadeInAnimation>
        </>
    );
};

export default BuildingHeader;

BuildingHeader.propTypes = {
    selectedBuilding: PropTypes.object,
    selectedBuildingRoomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    city: PropTypes.object,
};

